import { Injectable } from '@angular/core';
import { environment } from '@app-environments/environment';
import { API_ROUTES } from '@app-shared/constants/routes/api.routes';
import { ApiRequest } from '../api.request';
import {
  BaseGetByIdRequest,
  BaseGetCollectionResponse,
  BaseId,
  BaseResponse,
} from '@app-types/base/base';
import {
  GetByTypeRequest,
  InsertTagRequest,
  TagContract,
} from '@app-types/api/tag';
import { BaseCollectionFilteredSearchByIdRequest } from '@app-types/common';
import { TagSearchOrder, TagType } from '@app-types/enums/tags';
import { FileRefContract } from '@app-types/api/file';
import {
  SETTING_SETTINGS,
  defaultFilter,
} from '@app-shared/constants/constants';

const API_URL = environment.apiUrl;
const { tag } = API_ROUTES;
const {
  insert,
  update,
  getForMailAccount,
  searchForMailAccount,
  getSearchCountForMailAccount,
  exportExcel,
} = tag;

@Injectable({
  providedIn: 'root',
})
export class TagClient {
  constructor(private apiRequest: ApiRequest) {}

  async getForMailAccount(
    request: GetByTypeRequest
  ): Promise<BaseGetCollectionResponse<TagContract>> {
    return this.apiRequest.get<BaseGetCollectionResponse<TagContract>>(
      `${API_URL}${getForMailAccount}?${request.format()}`
    );
  }

  async searchForMailAccount(
    request:
      | BaseCollectionFilteredSearchByIdRequest<TagSearchOrder>
      | { type: TagType }
  ): Promise<BaseGetCollectionResponse<TagContract>> {
    return this.apiRequest.post(
      request,
      `${API_URL}${searchForMailAccount}`,
      null
    );
  }

  async searchTagsForSelect(
    mailAccountId: number,
    type: TagType,
    search: string | null = null,
    offset = 0,
    fetch = SETTING_SETTINGS.STEP_FETCH
  ): Promise<BaseGetCollectionResponse<TagContract>> {
    return this.searchForMailAccount({
      mailAccountId,
      offset,
      fetch,
      filter: { ...defaultFilter },
      search,
      type,
    });
  }

  async exportExcel(
    request: BaseGetByIdRequest
  ): Promise<BaseResponse<FileRefContract>> {
    return this.apiRequest.get(`${API_URL}${exportExcel}?${request.format()}`);
  }

  async getSearchCountForMailAccount(
    request: GetByTypeRequest
  ): Promise<BaseResponse<number>> {
    return this.apiRequest.get<BaseResponse<number>>(
      `${API_URL}${getSearchCountForMailAccount}?${request.format()}`
    );
  }

  async insert(request: InsertTagRequest): Promise<{ id: number }> {
    return await this.apiRequest.post<InsertTagRequest, void>(
      request,
      `${API_URL}${insert}`
    );
  }

  async updateTag(request: TagContract): Promise<void> {
    return await this.apiRequest.post<TagContract, void>(
      request,
      `${API_URL}${update}`
    );
  }

  async delete(request: BaseId): Promise<void> {
    return await this.apiRequest.post<BaseId, void>(
      request,
      `${API_URL}${tag.delete}`
    );
  }
}
